import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import ProgressBar from "./ProgressBar";
import QuotesSalesProgressBox from "./QuotesSalesProgressBox";
import LeftToEarnBox from "./LeftToEarnBox";
import moneyBill from "../images/MoneyBill.svg";
import trophy from "../images/Trophy.svg";
import confetti from "../images/Confetti.svg";
import "../styles/SelectedCapSpif.css";

const SelectedCapSpif = ({
  promotionType,
  iteration,
  nextPayout,
  maxNumberOfPayOuts,
}) => {
  const navigate = useNavigate();
  const [currentSvg, setCurrentSvg] = useState(null);
  const [confettiKey, setConfettiKey] = useState(0);
  const [isSpifCompleted, setIsSpifCompleted] = useState(false);

  const completedPayOuts = iteration - 1;
  const totalEarnings = (nextPayout * maxNumberOfPayOuts).toLocaleString();

  const routeToEarnings = () => {
    navigate("/earnings", { state: { editMode: true } });
  };

useEffect(() => {
  const isCompleted = completedPayOuts === maxNumberOfPayOuts;
  setIsSpifCompleted(isCompleted);
  
  if (completedPayOuts === 0 && !isCompleted) {
    setCurrentSvg(moneyBill);
  } else if (isCompleted) {
    setCurrentSvg(trophy);
    setConfettiKey((prevKey) => prevKey + 1);
  }
}, [completedPayOuts, maxNumberOfPayOuts]);


  return (
    <div className="selected-cap-spif">
      {isSpifCompleted ? (
        <div
          className="celebration-container-cap-spif"
          data-testid="celebration-container"
        >
          {currentSvg && (
            <div>
              <img
                src={currentSvg}
                alt="Trophy svg"
                className="trophy-svg-cap-spif"
              />
              <img
                src={confetti}
                alt="Confetti svg"
                className="confetti-svg-cap-spif"
                key={confettiKey}
              />
            </div>
          )}
          <div className="yes-progress-text-cap-spif">Congrats!</div>
          <div className="payout-background-cap-spif">
            <div className="payout-text-cap-spif">
              You've completed the promotion and earned{" "}
              <span className="payout-amount-cap-spif">${totalEarnings}</span>.
            </div>
          </div>
          <div className="earnings-link-container-cap-spif">
            <button
              onClick={routeToEarnings}
              className="earnings-link-cap-spif"
              type="button"
              data-trackid="view-promotion-earnings"
            >
              View My Earnings
            </button>
          </div>
        </div>
      ) : (
        <>
          {completedPayOuts === 0 ? (
            <div>
              {currentSvg && (
                <img
                  src={currentSvg}
                  alt="Money bill svg"
                  className="money-bill-svg"
                />
              )}
              <div className="no-progress-text">Sell GEICO, Earn Rewards</div>
              <div className="earnings-link-container-cap-spif">
                <button
                  onClick={routeToEarnings}
                  className="earnings-link-cap-spif"
                  type="button"
                  data-trackid="view-promotion-earnings"
                >
                  View My Earnings
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="progress-boxes-container-cap-spif">
                <QuotesSalesProgressBox
                  promotionType={promotionType}
                  progress={completedPayOuts}
                  cap={maxNumberOfPayOuts}
                />
                <LeftToEarnBox
                  promotionType={promotionType}
                  progress={completedPayOuts}
                  cap={maxNumberOfPayOuts}
                  payout={totalEarnings}
                />
              </div>
              <div className="progress-bar-container-cap-spif">
                <ProgressBar
                  promotionType={promotionType}
                  progress={completedPayOuts}
                  goal={maxNumberOfPayOuts}
                  payout={totalEarnings}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

SelectedCapSpif.propTypes = {
  promotionType: PropTypes.string,
  iteration: PropTypes.number,
  nextPayout: PropTypes.number,
  maxNumberOfPayOuts: PropTypes.number,
};

export default SelectedCapSpif;
